import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export interface MosaicGalleryHeaderData {
  title: string;
  total: number | undefined;
  selected: number;
  totalSelected: number;
}

@Component({
    selector: 'ts-mosaic-section-header',
    templateUrl: './mosaic-section-header.component.html',
    styleUrls: ['./mosaic-section-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MosaicSectionHeaderComponent {
  @Input() data: MosaicGalleryHeaderData;
}
